<template>
  <div style="height:100%">
    <el-card class="box-card mb-2" :body-style="{ padding: '2px' }" shadow="always">
      <div ref="hb_table_query_container">
        <b-row>
          <b-col sm="auto" style="padding-top: 6px; padding-right: 2px">
            <i class="iconfont icon-search"></i><span style="margin: 4px">查询条件</span>
          </b-col>
          <b-col sm="auto" class="pl-1">
            {{ $t("common.customer") + $t("common.name") }}：<el-input clearable size="small"
              style="width: 200px"></el-input>
            物料名称：<el-input clearable size="small" style="width: 200px"></el-input>
          </b-col>
          <b-col sm="auto" style="padding-left: 2px; padding-right: 2px">
            物料家族：
            <el-cascader v-model="typeChoose" size="small" :options="familyOptions" :props="props" collapse-tags
              clearable style="width: 300px">
            </el-cascader>
          </b-col>
          <b-col class="pl-1">
            <el-button type="primary" class="iconfont icon-search" size="small" @click="onSearch">查询</el-button>
          </b-col>
        </b-row>
      </div>
    </el-card>
    <div ref="hb_table_toolbar_container">
      <div class="mt-1 mb-2 ml-2">
        <b-row align-v="center">
          <!-- 表名 -->
          <b-col sm="auto">
            <slot name="header">
              <i class="iconfont icon-table" style="font-size: 16px"><span class="ml-1"
                  style="font-size: 12px"><strong>安全库存</strong></span></i>
            </slot>
          </b-col>
        </b-row>
      </div>
    </div>
    <b-table-simple small striped hover caption-top responsive bordered style="height:100%">
      <b-thead>
        <b-tr style="text-align: center; vertical-align: middle">
          <b-th colspan="1" rowspan="2" style="vertical-align: middle">编号</b-th>
          <b-th colspan="1" rowspan="2" style="vertical-align: middle">客户名称</b-th>
          <b-th colspan="1" rowspan="2" style="vertical-align: middle">销售公司</b-th>
          <b-th colspan="1" rowspan="2" style="vertical-align: middle">物料名称</b-th>
          <b-th colspan="1" rowspan="2" style="vertical-align: middle">一级分类</b-th>
          <b-th colspan="1" rowspan="2" style="vertical-align: middle">二级分类</b-th>
          <b-th colspan="1" rowspan="2" style="vertical-align: middle">三级分类</b-th>
          <b-th colspan="1" rowspan="2" style="vertical-align: middle">当前库存</b-th>
          <b-th colspan="2" style="vertical-align: middle">安全库存M1</b-th>
          <b-th colspan="2" style="vertical-align: middle">安全库存M2</b-th>
          <b-th colspan="2" style="vertical-align: middle">安全库存M3</b-th>
          <b-th colspan="2" style="vertical-align: middle">安全库存M4</b-th>
          <b-th colspan="2" style="vertical-align: middle">安全库存M5</b-th>
          <b-th colspan="2" style="vertical-align: middle">安全库存M6</b-th>
        </b-tr>
        <b-tr style="text-align: center; vertical-align: middle">
          <b-th colspan="1" style="vertical-align: middle">safety stock</b-th>
          <b-th colspan="1" style="vertical-align: middle">reorder point</b-th>
          <b-th colspan="1" style="vertical-align: middle">safety stock</b-th>
          <b-th colspan="1" style="vertical-align: middle">reorder point</b-th>
          <b-th colspan="1" style="vertical-align: middle">safety stock</b-th>
          <b-th colspan="1" style="vertical-align: middle">reorder point</b-th>
          <b-th colspan="1" style="vertical-align: middle">safety stock</b-th>
          <b-th colspan="1" style="vertical-align: middle">reorder point</b-th>
          <b-th colspan="1" style="vertical-align: middle">safety stock</b-th>
          <b-th colspan="1" style="vertical-align: middle">reorder point</b-th>
          <b-th colspan="1" style="vertical-align: middle">safety stock</b-th>
          <b-th colspan="1" style="vertical-align: middle">reorder point</b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <b-tr v-for="item in stock" :key="item" @click="selectRow(item)">
          <b-td>{{ item.index }}</b-td>
          <b-td>{{ item.custName }}</b-td>
          <b-td>{{ item.company }}</b-td>
          <b-td>{{ item.itemName }}</b-td>
          <b-td>{{ item.itemType1 }}</b-td>
          <b-td>{{ item.itemType2 }}</b-td>
          <b-td>{{ item.itemType3 }}</b-td>
          <b-td>{{ item.qty }}</b-td>
          <b-td variant="success">{{ item.m1.ss }}</b-td>
          <b-td variant="success">{{ item.m1.rp }}</b-td>
          <b-td variant="warning">{{ item.m2.ss }}</b-td>
          <b-td variant="warning">{{ item.m2.rp }}</b-td>
          <b-td variant="danger">{{ item.m3.ss }}</b-td>
          <b-td variant="danger">{{ item.m3.rp }}</b-td>
          <b-td variant="info">{{ item.m4.ss }}</b-td>
          <b-td variant="info">{{ item.m4.rp }}</b-td>
          <b-td variant="secondary">{{ item.m5.ss }}</b-td>
          <b-td variant="secondary">{{ item.m5.rp }}</b-td>
          <b-td variant="dark">{{ item.m6.ss }}</b-td>
          <b-td variant="dark">{{ item.m6.rp }}</b-td>
        </b-tr>
      </b-tbody>
    </b-table-simple>
    <b-row align-v="start">
      <b-col sm="auto">
        <el-pagination v-if="page_sizes !== null" :pager-count="pager_count" @size-change="handleSizeChange"
          @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="page_sizes"
          :page-size="page_sizes[0]" :layout="pager_layout" :total="items_count">
        </el-pagination>
      </b-col>
    </b-row>
    <el-drawer :title="title" :visible.sync="drawer" :direction="direction" size="50%">
      <div slot="title">
        <span>客户:</span>
        <el-tag type="danger" effect="dark" class="ml-2">{{ title.custName }}</el-tag><span class="ml-2">物料:</span>
        <el-tag type="danger" effect="dark" class="ml-2">{{ title.itemName }}</el-tag>
      </div>
      <div class="el-tabs-container">
        <el-tabs v-model="tab_index1">
          <el-tab-pane label="Basic Safety Stock Formula">
            <div style="border: 1px #999 solid">
              <el-card>
                <div class="mb-2">
                  Average Sale(AS) =
                  <el-tag type="danger" effect="dark">100 qty/day</el-tag>
                </div>
                <div class="mb-2">
                  Safety Stock(SS) = 100 * 5 =
                  <el-tag type="danger" effect="dark">500 qty</el-tag>
                </div>
                <div>
                  Reorder Point = (SS) + AS * Lead Time = 500 + 100 * 10 =
                  <el-tag type="danger" effect="dark">1500 qty</el-tag>
                </div>
              </el-card>
            </div>
          </el-tab-pane>
          <el-tab-pane label="Average – Max Formula">
            <div style="border: 1px #999 solid">
              <el-card>
                <div class="mb-2">
                  <b-row>
                    <b-col>
                      <el-table :data="m2data" style="width: 100%; border: 1px #999 solid" size="mini" :border="true">
                        <el-table-column prop="month" label="Month" width="180">
                        </el-table-column>
                        <el-table-column prop="Sales" label="Sales" width="180">
                        </el-table-column>
                      </el-table>
                    </b-col>
                    <b-col>
                      <el-table :data="m2data2" style="width: 100%; border: 1px #999 solid" size="mini" :border="true">
                        <el-table-column prop="delivery" label="Delivery" width="180">
                        </el-table-column>
                        <el-table-column prop="lead_time" label="Lead Time(Day)" width="180">
                        </el-table-column>
                      </el-table>
                    </b-col>
                  </b-row>
                </div>
                <div class="mb-2">
                  Safety Stock(SS) = (Max Lead Time * Max Sale) - (Average Lead Time *
                  Average Sale) =
                  <el-tag type="danger" effect="dark">427 qty</el-tag>
                </div>
                <div>
                  Reorder Point = (SS) + Average Sale(or Foreacast) * Average Lead Time =
                  <el-tag type="danger" effect="dark">1578 qty</el-tag>
                </div>
              </el-card>
            </div>
          </el-tab-pane>
          <el-tab-pane label="Normal Distribution with uncertainty about the demand">
            <div style="border: 1px #999 solid">
              <el-card>
                <div class="mb-2">
                  Z * Demand Standard Deviation * sqrt(Average LT) =
                  <el-tag type="danger" effect="dark">1,28 * 141,4 * sqrt(1,15)</el-tag>
                </div>
              </el-card>
            </div>
          </el-tab-pane>
          <el-tab-pane label="Normal distribution with uncertainty on the lead time">
            <div style="border: 1px #999 solid">
              <el-card>
                <div class="mb-2">
                  Z * Average Sale * Lead Time Standard Deviation =
                  <el-tag type="danger" effect="dark">1,28 * 1000 * 0,14</el-tag>
                </div>
              </el-card>
            </div>
          </el-tab-pane>
          <el-tab-pane label="Normal distribution with uncertainty on-demand and independent lead time">
            <div style="border: 1px #999 solid">
              <el-card>
                <div class="mb-2">
                  Z * sqrt((Average LT * (Demand Standard Deviation)² + (Average Sale * Lead Time Standard Deviation)²)
                </div>
              </el-card>
            </div>
          </el-tab-pane>
          <el-tab-pane label="Normal distribution with uncertainty on demand and dependent lead time">
            <div style="border: 1px #999 solid">
              <el-card>
                <div class="mb-2">
                  Z * Demand Standard Deviation * sqrt(Average LT) + Z * Average Sale * Lead Time Standard Deviation
                </div>
              </el-card>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-drawer>
  </div>
</template>

<script>
// -- import * as _ from "lodash-es"
import QueryButton from "../components/base/QueryButton"
export default {
  name: "NetDemandPlan",
  components: { QueryButton },
  data() {
    return {
      m2data: [
        {
          month: "Jan",
          Sales: 900,
        },
        {
          month: "Feb",
          Sales: 1000,
        },
        {
          month: "Mar",
          Sales: 800,
        },
        {
          month: "Apr",
          Sales: 1100,
        },
        {
          month: "May",
          Sales: 900,
        },
        {
          month: "June",
          Sales: 1200,
        },
        {
          month: "July",
          Sales: 900,
        },
        {
          month: "Aug",
          Sales: 1100,
        },
        {
          month: "Sep",
          Sales: 1100,
        },
        {
          month: "Oct",
          Sales: 1000,
        },
        {
          month: "Nov",
          Sales: 800,
        },
        {
          month: "Dec",
          Sales: 1200,
        },
        {
          month: "TOTAL",
          Sales: 12000,
        },
        {
          month: "Average/Month",
          Sales: 1100,
        },
        {
          month: "Average/Day",
          Sales: 32.9,
        },
        {
          month: "Sale MAX",
          Sales: 39.5,
        },
      ],
      m2data2: [
        { delivery: 1, lead_time: 38 },
        { delivery: 2, lead_time: 57 },
        { delivery: 3, lead_time: 38 },
        { delivery: 4, lead_time: 40 },
        { delivery: 5, lead_time: 33 },
        { delivery: 6, lead_time: 28 },
        { delivery: 7, lead_time: 37 },
        { delivery: 8, lead_time: 36 },
        { delivery: 9, lead_time: 36 },
        { delivery: 10, lead_time: 27 },
        { delivery: "Average Lead Time", lead_time: 35 },
        { delivery: "MAX Lead Time", lead_time: 40 },
      ],
      title: {},
      tableData: [],
      drawer: false,
      direction: "rtl",
      props: { multiple: true },
      tab_index: 0,
      tab_index1: 0,
      stock: [],
      weekdata: {
        col: [{ name: "W1" }, { name: "W2" }, { name: "W3" }, { name: "W4" }],
        datas: [],
      },
      comparisondata: {
        col: [{ name: "W1" }, { name: "W2" }, { name: "W3" }, { name: "W4" }],
        datas: [],
      },
      dateOptions: [],
      dateChoose: 1,
      typeOptions: [],
      familyOptions: [],
      typeChoose: [],
      searchType: 7,
      searchTypeRow: 2,
      changeState: 1,
      page_sizes: [50, 100, 200],
      pager_count: 7,
      currentPage: 1,
      perPage: 0,
      pager_layout: "total, sizes, prev, pager, next, jumper",
    }
  },
  computed: {
    items_count() {
      return this.weekdata.datas.length
    },
  },
  created() {
    //this.makeData();
    this.dateOptions.push({ label: "按周查询", value: 1 })
    this.dateOptions.push({ label: "按月查询", value: 2 })
    this.dateOptions.push({ label: "按季度查询", value: 3 })
    this.typeOptions.push({ label: "attribute1", value: "attribute1" })
    this.typeOptions.push({ label: "attribute2", value: "attribute2" })
    this.typeOptions.push({ label: "attribute3", value: "attribute3" })

    this.familyOptions.push(
      {
        label: "Type A",
        value: "Type A",
        children: [
          {
            label: "type A-1",
            value: "type A-1",
            children: [
              { label: "type A-1-1", value: "type A-1-1" },
              { label: "type A-1-2", value: "type A-1-2" },
              { label: "type A-1-3", value: "type A-1-3" },
            ],
          },
          {
            label: "type A-2",
            value: "type A-2",
            children: [
              { label: "type A-2-1", value: "type A-2-1" },
              { label: "type A-2-2", value: "type A-2-2" },
              { label: "type A-2-3", value: "type A-2-3" },
            ],
          },
          {
            label: "type A-3",
            value: "type A-3",
            children: [
              { label: "type A-3-1", value: "type A-3-1" },
              { label: "type A-3-2", value: "type A-3-2" },
              { label: "type A-3-3", value: "type A-3-3" },
            ],
          },
        ],
      },
      {
        label: "Type B",
        value: "Type B",
        children: [
          {
            label: "type B-1",
            value: "type B-1",
            children: [
              { label: "type B-1-1", value: "type B-1-1" },
              { label: "type B-1-2", value: "type B-1-2" },
              { label: "type B-1-3", value: "type B-1-3" },
            ],
          },
          {
            label: "type B-2",
            value: "type B-2",
            children: [
              { label: "type B-2-1", value: "type B-2-1" },
              { label: "type B-2-2", value: "type B-2-2" },
              { label: "type B-2-3", value: "type B-2-3" },
            ],
          },
          {
            label: "type B-3",
            value: "type B-3",
            children: [
              { label: "type B-3-1", value: "type B-3-1" },
              { label: "type B-3-2", value: "type B-3-2" },
              { label: "type B-3-3", value: "type B-3-3" },
            ],
          },
        ],
      },
      {
        label: "Type C",
        value: "Type C",
        children: [
          {
            label: "type C-1",
            value: "type C-1",
            children: [
              { label: "type C-1-1", value: "type C-1-1" },
              { label: "type C-1-2", value: "type C-1-2" },
              { label: "type C-1-3", value: "type C-1-3" },
            ],
          },
          {
            label: "type C-2",
            value: "type C-2",
            children: [
              { label: "type C-2-1", value: "type C-2-1" },
              { label: "type C-2-2", value: "type C-2-2" },
              { label: "type C-2-3", value: "type C-2-3" },
            ],
          },
          {
            label: "type C-3",
            value: "type C-3",
            children: [
              { label: "type C-3-1", value: "type C-3-1" },
              { label: "type C-3-2", value: "type C-3-2" },
              { label: "type C-3-3", value: "type C-3-3" },
            ],
          },
        ],
      }
    )
  },
  watch: {},
  methods: {
    selectRow(val) {
      console.log(val)
      this.comparisonData()
      this.drawer = true
      this.title.custName = val.custName
      this.title.itemName = val.itemName
      this.calcData()
    },
    calcData() {
      this.tableData = []
      this.tableData.push(
        {
          month: "Oct",
          week: 1,
          forecast: 20,
          custOrders: 19,
          order_purchase: 31,
          order_production: 14,
          order_trans: null,
          net_demand: 56,
        },
        {
          month: "Oct",
          week: 2,
          forecast: 22,
          custOrders: 170,
          order_purchase: null,
          order_production: 30,
          order_trans: 30,
          net_demand: -76,
        },
        {
          month: "Oct",
          week: 3,
          forecast: 21,
          custOrders: 15,
          order_purchase: 30,
          order_production: 90,
          order_trans: null,
          net_demand: 3,
        },
        {
          month: "Oct",
          week: 4,
          forecast: 25,
          custOrders: 11,
          order_purchase: 90,
          order_production: null,
          order_trans: null,
          net_demand: -3,
        },
        {
          month: "Nov",
          week: 1,
          forecast: 24,
          custOrders: 9,
          order_purchase: null,
          order_production: null,
          order_trans: null,
          net_demand: -36,
        },
        {
          month: "Nov",
          week: 2,
          forecast: 23,
          custOrders: 5,
          order_purchase: 20,
          order_production: 30,
          order_trans: null,
          net_demand: -14,
        },
        {
          month: "Nov",
          week: 3,
          forecast: 21,
          custOrders: 2,
          order_purchase: 50,
          order_production: null,
          order_trans: null,
          net_demand: 13,
        },
        {
          month: "Nov",
          week: 4,
          forecast: 21,
          custOrders: 1,
          order_purchase: null,
          order_production: 60,
          order_trans: null,
          net_demand: 51,
        }
      )
    },
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
      this.perPage = val
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.currentPage = val
    },

    onSearch() {
      let self = this
      this.makeData()
    },
    makeData() {
      for (var j = 0; j < 18; j++) {
        this.stock.push({
          index: j + 1,
          custName: "user",
          company: "070",
          itemName: "item" + (j + 1),
          itemType1: j < 6 ? "Type A" : j > 11 ? "Type C" : "Type B",
          itemType2: j < 6 ? "type A-1" : j > 11 ? "type C-1" : "type B-1",
          itemType3: j < 6 ? "type A-1-1" : j > 11 ? "type C-1-1" : "type B-1-1",
          qty: 100,
          m1: { ss: 500, rp: 1500 },
          m2: { ss: 427, rp: 1578 },
          m3: { ss: 194, rp: 1345 },
          m4: { ss: 183, rp: 1333 },
          m5: { ss: 267, rp: 1417 },
          m6: { ss: 377, rp: 1527 },
        })
      }
    },
    comparisonData() {
      this.comparisondata.days = []
      this.comparisondata.datas = []
      this.comparisondata.col = []

      this.comparisondata.col.push({ name: "W1" })
      this.comparisondata.col.push({ name: "W2" })
      this.comparisondata.col.push({ name: "W3" })
      this.comparisondata.col.push({ name: "W4" })
      for (var i = 0; i < 28; i++) {
        let date = new Date()
        this.comparisondata.days.push(
          this.$date.format(this.$date.addDays(date, i), "M.d")
        )
      }

      this.comparisondata.datas.push(
        {
          version: "Forecast-V1",
          monthdata: [
            { data: 2000, color: "primary" },
            { data: 3000, color: "primary" },
            { data: 4000, color: "primary" },
            { data: 3000, color: "primary" },
            { data: 5000, color: "primary" },
            { data: 6000, color: "primary" },
            { data: 7000, color: "primary" },
            { data: 2000, color: "primary" },
            { data: 4000, color: "primary" },
            { data: 5000, color: "primary" },
            { data: 7000, color: "primary" },
            { data: 5600, color: "primary" },
            { data: 4500, color: "primary" },
            { data: 2400, color: "primary" },
            { data: 3000, color: "primary" },
            { data: 4000, color: "primary" },
            { data: 5000, color: "primary" },
            { data: 6000, color: "primary" },
            { data: 8000, color: "primary" },
            { data: 9000, color: "primary" },
            { data: 10000, color: "primary" },
            { data: 10000, color: "primary" },
            { data: 11000, color: "primary" },
            { data: 12000, color: "primary" },
            { data: 13000, color: "primary" },
            { data: 14000, color: "primary" },
            { data: 15000, color: "primary" },
            { data: 16000, color: "primary" },
          ],
        },
        {
          version: "Forecast-V2",
          monthdata: [
            { data: 0, color: "success" },
            { data: 2000, color: "success" },
            { data: 5000, color: "success" },
            { data: 2000, color: "success" },
            { data: 4000, color: "success" },
            { data: 3000, color: "success" },
            { data: 8000, color: "success" },
            { data: 3000, color: "primary" },
            { data: 3000, color: "primary" },
            { data: 6000, color: "primary" },
            { data: 9000, color: "primary" },
            { data: 3000, color: "primary" },
            { data: 6000, color: "primary" },
            { data: 4000, color: "primary" },
            { data: 3000, color: "primary" },
            { data: 4000, color: "primary" },
            { data: 5000, color: "primary" },
            { data: 6000, color: "primary" },
            { data: 8000, color: "primary" },
            { data: 9000, color: "primary" },
            { data: 10000, color: "primary" },
            { data: 10000, color: "primary" },
            { data: 11000, color: "primary" },
            { data: 12000, color: "primary" },
            { data: 13000, color: "primary" },
            { data: 14000, color: "primary" },
            { data: 15000, color: "primary" },
            { data: 16000, color: "primary" },
          ],
        },
        {
          version: "Order",
          monthdata: [
            { data: null, color: "primary" },
            { data: null, color: "primary" },
            { data: null, color: "primary" },
            { data: null, color: "primary" },
            { data: null, color: "primary" },
            { data: null, color: "primary" },
            { data: null, color: "primary" },
            { data: null, color: "primary" },
            { data: null, color: "primary" },
            { data: null, color: "primary" },
            { data: 8000, color: "success" },
            { data: null, color: "primary" },
            { data: null, color: "primary" },
            { data: null, color: "primary" },
            { data: 2000, color: "success" },
            { data: 3000, color: "success" },
            { data: 6000, color: "success" },
            { data: 7000, color: "success" },
            { data: 7500, color: "success" },
            { data: 3000, color: "success" },
            { data: 8000, color: "success" },
            { data: null, color: "primary" },
            { data: null, color: "primary" },
            { data: null, color: "primary" },
            { data: null, color: "primary" },
            { data: null, color: "primary" },
            { data: null, color: "primary" },
            { data: null, color: "primary" },
          ],
        },
        {
          version: "Forecast Balance V1",
          monthdata: [
            { data: null, color: "primary" },
            { data: null, color: "primary" },
            { data: null, color: "primary" },
            { data: null, color: "primary" },
            { data: null, color: "primary" },
            { data: null, color: "primary" },
            { data: null, color: "primary" },
            { data: 3000, color: "primary" },
            { data: 3000, color: "primary" },
            { data: 6000, color: "primary" },
            { data: 1000, color: "primary" },
            { data: 3600, color: "primary" },
            { data: 6500, color: "primary" },
            { data: 4400, color: "primary" },
            { data: 3000, color: "primary" },
            { data: 4000, color: "primary" },
            { data: 5000, color: "primary" },
            { data: 6000, color: "primary" },
            { data: 8000, color: "primary" },
            { data: 9000, color: "primary" },
            { data: 10000, color: "primary" },
            { data: 10000, color: "primary" },
            { data: 11000, color: "primary" },
            { data: 12000, color: "primary" },
            { data: 13000, color: "primary" },
            { data: 14000, color: "primary" },
            { data: 15000, color: "primary" },
            { data: 16000, color: "primary" },
          ],
        },
        {
          version: "Forecast Balance V2",
          monthdata: [
            { data: null, color: "primary" },
            { data: null, color: "primary" },
            { data: null, color: "primary" },
            { data: null, color: "primary" },
            { data: null, color: "primary" },
            { data: null, color: "primary" },
            { data: null, color: "primary" },
            { data: 0, color: "primary" },
            { data: 0, color: "primary" },
            { data: 0, color: "primary" },
            { data: 0, color: "primary" },
            { data: 0, color: "primary" },
            { data: 2000, color: "primary" },
            { data: 4000, color: "primary" },
            { data: 3000, color: "primary" },
            { data: 4000, color: "primary" },
            { data: 5000, color: "primary" },
            { data: 6000, color: "primary" },
            { data: 8000, color: "primary" },
            { data: 9000, color: "primary" },
            { data: 10000, color: "primary" },
            { data: 10000, color: "primary" },
            { data: 11000, color: "primary" },
            { data: 12000, color: "primary" },
            { data: 13000, color: "primary" },
            { data: 14000, color: "primary" },
            { data: 15000, color: "primary" },
            { data: 16000, color: "primary" },
          ],
        }
      )
    },
  },
}
</script>

<style>
.hb_table_forecast_class1 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 150rem;
}

.hb_table_forecast_class2 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 65rem;
}

.hb_table_forecast_class3 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 115rem;
}
</style>

<style scoped>
.one_table>>>.hb_table_query_container_one_table {
  background-color: white;
}

.hb_table_panel_container_myName>>>.b-table-sticky-header>.table.b-table>.hb_thead>.hb_thead_tr>.b-table-sticky-column.hb_thead_th_name {
  left: 21px;
}

.hb_table_panel_container_myName>>>.b-table-sticky-header>.table.b-table>.hb_tbody>.hb_tbody_tr>.b-table-sticky-column.hb_tbody_td_name {
  left: 21px;
}
</style>
